/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 发展历程
  DevelopmentHistory: () => import(/* webpackChunkName: "dict" */ '@/views/page/DevelopmentHistory/index'),
  // 企业荣誉
  BusinessesGlory: () => import(/* webpackChunkName: "dict" */ '@/views/page/Businesses/Glory/index'),
  // 企业证书
  BusinessesCertificate: () => import(/* webpackChunkName: "dict" */ '@/views/page/Businesses/Certificate/index'),
  // 合作伙伴
  Partners: () => import(/* webpackChunkName: "dict" */ '@/views/page/Partners/index'),

  AnnualReport: () => import(/* webpackChunkName: "dict" */ '@/views/page/AnnualReport/index'),

  Directorate: () => import(/* webpackChunkName: "dict" */ '@/views/page/Directorate/index')
};

export const BusinessesRoute = [
  {
    path: '/Businesses',
    component: Layout,
    name: 'Businesses',
    isMenu: true,
    redirect: { name: 'DevelopmentHistory' },
    meta: { title: '索菱发展', icon: 'menu_qiyeshezhi'},
    children: [
      {
        path: 'developmentHistory',
        name: 'DevelopmentHistory',
        component: routes['DevelopmentHistory'],
        meta: { title: '发展历程'}
      },
      {
        path: 'glory',
        name: 'BusinessesGlory',
        component: routes['BusinessesGlory'],
        meta: { title: '企业荣誉'}
      },
      {
        path: 'certificate',
        name: 'BusinessesCertificate',
        component: routes['BusinessesCertificate'],
        meta: { title: '企业证书'}
      },
      {
        path: 'partners',
        name: 'Partners',
        component: routes['Partners'],
        meta: { title: '合作伙伴'}
      },
      {
        path: 'directorate',
        name: 'Directorate',
        component: routes['Directorate'],
        meta: { title: '董事成员'}
      },
      // {
      //   path: 'annualReport',
      //   name: 'annualReport',
      //   component: routes['AnnualReport'],
      //   meta: { title: '企业财报'}
      // }
    ]
  }
];
